import React, { ReactNode } from 'react';
import {
  Dialog,
  Box,
  Typography,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './Modal.scss';

interface ModalProps {
  open: boolean;
  title?: string;
  children?: ReactNode;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ open, title, children, onClose }) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: {
            xs: '90%',
            sm: '819px',
            md: '819px',
            lg: '819px',
            xl: '819px',
          },
        },
      }}
      className="modal-container"
      open={open}
      onClose={onClose}
    >
      <Box className="modal-box">
        <DialogTitle className="modal-header">
          <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>
            {title}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            className="modal-close-button"
          >
            <CloseIcon fontSize="large" className="close-icon" />
          </IconButton>
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
      </Box>
    </Dialog>
  );
};

export default Modal;
